export default ".btn {\n  min-width: 84px;\n}\n\n.bg-disabled {\n  background-color: grey !important;\n  border-color: grey !important;\n  opacity: 0.65;\n}";